import { Chapter } from './../../resource/question/question.model';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import { BuildQuestion } from './add-question-util';
import tableExample from './add-question-template/add-table';
import listExample from './add-question-template/add-list';
import fillInBlankExample from './add-question-template/add-fill-in-blank';
import answerExample from './add-question-template/add-answer';
import textExample from './add-question-template/add-text';
import imageExample from './add-question-template/add-image';
import parentExample from './add-question-template/add-parent';
import attachmentExample from './add-question-template/add-attachment';
import questionExample from './add-question-template/add-question';

export const questionTypeToggles = [
  { id: false, value: 'Objective' },
  { id: true, value: 'Subjective' },
];

export const languageToggles = [
  { id: QuestionLanguage.malay, value: 'Malay' },
  { id: QuestionLanguage.english, value: 'English' },
  { id: 'multi' as QuestionLanguage, value: 'Multilanguage' },
];

export const difficultyToggles = [
  { id: '1', value: '1' },
  { id: '2', value: '2' },
  { id: '3', value: '3' },
];

export const dummyChapter: Chapter = {
  id: 1,
  name: 'Basic Grammar',
  prefix: 1,
  form: 7,
  createdAt: new Date(),
  updatedAt: new Date(),
  subject: {
    id: 1,
    uuid: 'english',
    name: 'English',
    languages: [QuestionLanguage.english],
    createdAt: new Date(),
    updatedAt: new Date(),
    forms: [],
    chapters: [],
    subjectTypes: [],
    isAvailLowerForm: false,
    isAvailUpperForm: false,
    isAvailElementary: false,
    isNoLevel: false,
    // isAvailPreCollectionLowerForm: false,
    // isAvailPreCollectionUpperForm: false,
    // isAvailPreCollectionElementary: false,
  },
};

export const subjectiveComponentTemplates = [
  {
    text: 'Text',
    title: 'Insert a Text',
    className: 'jsoneditor-type-object',
    field: 'Text Field',
    value: textExample,
  },
  {
    text: 'Image',
    title: 'Insert a Image',
    className: 'jsoneditor-type-object',
    field: 'Image Field',
    value: imageExample,
  },
  {
    text: 'Table',
    title: 'Insert a Table',
    className: 'jsoneditor-type-object',
    field: 'Table Field',
    value: tableExample,
  },
  {
    text: 'List',
    title: 'Insert a List',
    className: 'jsoneditor-type-object',
    field: 'List Field',
    value: listExample,
  },
  {
    text: 'Fill In Blank',
    title: 'Insert a Fill In Blank',
    className: 'jsoneditor-type-object',
    field: 'Fill In Blank Field',
    value: fillInBlankExample,
  },
  {
    text: 'Answer',
    title: 'Insert a Answer',
    className: 'jsoneditor-type-object',
    field: 'Answer Field',
    value: answerExample,
  },
  {
    text: 'Attachment',
    title: 'Insert a Attachment',
    className: 'jsoneditor-type-object',
    field: 'Attachment Field',
    value: attachmentExample,
  },
  {
    text: 'Parent',
    title: 'Insert a Parent',
    className: 'jsoneditor-type-object',
    field: 'Parent Field',
    value: parentExample(),
  },
  {
    text: 'Full Questions',
    title: 'Insert Full Questions',
    className: 'jsoneditor-type-object',
    field: 'Full Questions Field',
    value: questionExample,
  },
];

export const defaultSubjectiveBuildQuestion: BuildQuestion = {
  buildChapter: dummyChapter,
  languages: [QuestionLanguage.english],
  keywords: '',
  difficulty: 1,
  buildJson: parentExample([textExample, questionExample]),
  parentId: null,
  questionJson: null,
  questionHtmls: null,
  pdfHtmls: null,
  editorVersion: null,
};

export const defaultObjectiveBuildQuestion: BuildQuestion = {
  buildChapter: dummyChapter,
  languages: [QuestionLanguage.english],
  keywords: '',
  difficulty: 1,
  buildJson: {
    picture: 'https://picsum.photos/300/200',
    question: 'write question here',
    correctAnswers: ['this is best answer'],
    wrongAnswers: ['wrong answer 1', 'wrong answer 2'],
  },
  parentId: null,
  questionJson: null,
  questionHtmls: null,
  pdfHtmls: null,
  editorVersion: null,
};
